import React from 'react';
import { ModalTheme } from '../modal/index.jsx';
import { CustomerHistory } from './CustomerHistory';

// ประวัติลูกค้า (รายการลงทะเบียน + เคลมของแต่ละประกัน) ใช้ร่วมกันทั้งหน้าลูกค้าและหน้าเคลม
export const CustomerHistoryModal = ({ open, onToggle, initialValues }) => (
  <ModalTheme
    title={`ประวัติลูกค้า ${initialValues?.customerCode || ''} ${initialValues?.fullName || ''}`}
    open={open}
    onToggle={onToggle}
    width="90%"
  >
    <CustomerHistory record={initialValues} />
  </ModalTheme>
);
